import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from "@ngx-translate/core";

import { LzBookmarkTreeView } from './components/tree-view/tree-view.component';
import { LzBookmarkAddPageComponent } from './components/bookmark-add-page/add-page.component';
import { LzBookmarkCreateFolderComponent } from './components/bookmark-create-folder/bookmark-create-folder.component';

import { LzBookmarkService } from './services/lz-bookmark.service';

@NgModule({
  declarations: [
    LzBookmarkTreeView,
    LzBookmarkAddPageComponent,
    LzBookmarkCreateFolderComponent
  ],
  providers: [
    LzBookmarkService
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    TranslateModule
  ],
  entryComponents: [
    LzBookmarkTreeView,
    LzBookmarkAddPageComponent,
    LzBookmarkCreateFolderComponent
  ]
})

export class LzBookmarkModule {}
